module.exports = __webpack_public_path__ + "img/coin1.2fa3fa85.svg";